import { render, staticRenderFns } from "./WordPressSliderCard.vue?vue&type=template&id=60a15d51"
import script from "./WordPressSliderCard.vue?vue&type=script&lang=js"
export * from "./WordPressSliderCard.vue?vue&type=script&lang=js"
import style0 from "./WordPressSliderCard.vue?vue&type=style&index=0&id=60a15d51&prod&lang=scss"
import style1 from "./WordPressSliderCard.vue?vue&type=style&index=1&id=60a15d51&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports